import React, { useEffect } from 'react'

import { Modal } from 'pharmacy/src/display/modal'
import { Header2 } from 'pharmacy/src/typography'
import { Button } from 'pharmacy/src/input/button'

import { SEARCH_MODAL } from 'mednet-util/src/constants/modal'

import { useDispatch } from 'react-redux'
import { highlightSearchHeader } from 'mednet-cns/src/reducers/search'
import { useInView } from 'react-intersection-observer'

import { mixpanel } from 'mednet-util/src/tracking'

import css from './searchModal.scss'

const SearchModalContent = ({ closeModal }) => {
  const dispatch = useDispatch()

  const { ref, inView: inViewCta } = useInView({
    threshold: 0.6,
  })

  useEffect(() => {
    mixpanel.track('viewed_search_modal')
  }, [])

  useEffect(() => {
    if (inViewCta) {
      mixpanel.track('viewed_search_modal_cta_button')
    }
  }, [inViewCta])

  const handleCtaClick = () => {
    mixpanel.track('clicked_search_modal_cta_button')
    dispatch(highlightSearchHeader(true))
    closeModal()
  }

  const handleCloseModal = () => {
    mixpanel.track('closed_search_modal')
    closeModal()
  }

  return (
    <div className={css.modalContainer}>
      <button className={css.closeButton} onClick={handleCloseModal}>
        ×
      </button>

      <div className={css.iconContainer}>
        <div className={css.searchIcon}>
          <div className={css.icon}>🔍</div>
        </div>
      </div>

      <Header2 className={css.title}>New! Enhanced Search</Header2>

      <p className={css.subtitle}>
        A faster, smarter way to discover clinical insights.
      </p>

      <div className={css.featuresContainer}>
        <div className={css.featureItem}>
          <div className={css.featureIcon}>
            <div className={css.iconCircle}>❓</div>
          </div>
          <div className={css.featureContent}>
            <h3 className={css.featureTitle}>Full Question Search</h3>
            <p className={css.featureDescription}>
              Eg: When do you recommend a full respiratory pathogen panel for
              patients with URI?
            </p>
          </div>
        </div>

        <div className={css.featureItem}>
          <div className={css.featureIcon}>
            <div className={css.iconCircle}>📊</div>
          </div>
          <div className={css.featureContent}>
            <h3 className={css.featureTitle}>Keyword Search</h3>
            <p className={css.featureDescription}>Eg: multivitamin elderly</p>
          </div>
        </div>

        <div className={css.featureItem}>
          <div className={css.featureIcon}>
            <div className={css.iconCircle}>🎯</div>
          </div>
          <div className={css.featureContent}>
            <h3 className={css.featureTitle}>Topic Discovery</h3>
            <p className={css.featureDescription}>
              Eg: Metastatic HR+ Her2 negative breast cancer
            </p>
          </div>
        </div>
      </div>

      <div ref={ref}>
        <Button
          type="primary"
          className={css.ctaButton}
          onClick={handleCtaClick}
        >
          Try Search Now
        </Button>
      </div>
    </div>
  )
}

export const SearchModal = (props) => {
  return (
    <Modal
      modalId={SEARCH_MODAL.modalId}
      {...props}
      contentClassName={css.outerModalContainer}
      closeOnBackdrop={false}
    >
      <SearchModalContent />
    </Modal>
  )
}
